import Client from "shopify-buy";
import credentials from "../../../shopify";

const isProduction = location.hostname === 'www.automicgold.com';

export default Client.buildClient({
    domain: location.hostname,
    storefrontAccessToken: (isProduction ? credentials.accessToken.production : credentials.accessToken.development),
});
